<template>
    <div class="notifications-item" :data-level="item.level">
        <div class="notifications-item__time" v-text="dateStr" />
        <div class="notifications-item__indicator" :data-state="item.state" />
        <div class="notifications-item__message">
            <button @click.prevent="item.select" v-text="item.message" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationsItem',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        showDate: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dateStr() {
            const result = [this.item.formattedDate, this.item.formattedTime];
            if (!this.showDate) result.shift();
            return result.join(' ');
        },
    },
};
</script>

<style lang="scss" src="./NotificationsItem.scss"></style>
